import * as React from "react";
import { SVGProps, forwardRef } from "react";

/**
 * Native-select-style chevron used by `SelectInputLabel` (and select-like
 * widgets such as the schedule date pickers) to indicate open/closed
 * state. The icon points DOWN by default; consumers rotate it 180deg
 * when the dropdown is open and apply a `transform 0.2s ease`
 * transition for a smooth flip.
 *
 * Forwards refs because some consumers (e.g. `SelectInputLabel`) attach
 * a ref to the arrow for outside-click detection.
 */
const SvgSelectChevron = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke={props.stroke ?? "#6B7280"}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
);

SvgSelectChevron.displayName = "SvgSelectChevron";

export default SvgSelectChevron;
